<div
    *transloco="let t"
    class="bazis-empty"
    [ngClass]="cssClass()"
>
    @if (pathImg()) {
        <img
            [src]="pathImg()"
            alt="empty content decor"
        />
    }

    @if (titleKey()) {
        <h5>
            {{ t(titleKey(), titleParams()) }}
        </h5>
    }

    @if (messageKey()) {
        <p [innerHTML]="t(messageKey(), messageParams())"></p>
    }
    <ng-content></ng-content>

    @if (buttonOptions()) {
        <bazis-button
            [fill]="buttonOptions().fill || 'solid'"
            [color]="buttonOptions().color"
            [size]="buttonOptions().size"
            (click)="addAction($event)"
        >
            @if (buttonOptions().iconStart) {
                <bazis-icon
                    [icon]="buttonOptions().iconStart"
                    slot="start"
                ></bazis-icon>
            }
            @if (buttonOptions().iconEnd) {
                <bazis-icon
                    [icon]="buttonOptions().iconEnd"
                    slot="end"
                ></bazis-icon>
            }
            {{ t(buttonOptions().titleKey) }}
        </bazis-button>
    }

    @if (linkOptions()) {
        <bazis-link
            [href]="linkOptions().href"
            [target]="linkOptions().target"
            [size]="linkOptions().size"
            [borderStyle]="linkOptions().borderStyle"
        >
            @if (linkOptions().iconStart) {
                <bazis-icon
                    [icon]="linkOptions().iconStart"
                    slot="start"
                ></bazis-icon>
            }
            @if (linkOptions().iconEnd) {
                <bazis-icon
                    [icon]="linkOptions().iconEnd"
                    slot="end"
                ></bazis-icon>
            }
            {{ t(linkOptions().titleKey) }}
        </bazis-link>
    }
</div>
